/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * Meeting BaaS API
 * OpenAPI spec version: 1.1
 */

export type AudioFrequency = (typeof AudioFrequency)[keyof typeof AudioFrequency]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AudioFrequency = {
  "16khz": "16khz",
  "24khz": "24khz"
} as const
